import { CreativityContentData } from '../types/banner';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

dayjs.locale('es');

export const formatDate = (date: Date): string => {
  return dayjs(date).format('D [de] MMMM');
};

export const getBannerDate = (creativity: CreativityContentData): string => {
  const config = creativity.config;

  if (config && 'date' in config && config.date) {
    const date = new Date(config.date);
    const day = 'day' in config && config.day ? config.day.split(' - ')[0] : '';
    const formattedDate = formatDate(date);
    return day ? `${day} ${formattedDate}` : formattedDate;
  }

  // Fallback a createdAt
  return formatDate(new Date(creativity.createdAt ?? creativity.date));
};
